/**
 * Builds a Pinterest share URL for a detail image using absolute page/media URLs.
 */
interface BuildPinterestShareUrlOptions {
    pageUrl: string;
    mediaUrl: string;
    description?: string;
}

export const buildPinterestShareUrl = ({
    pageUrl,
    mediaUrl,
    description,
}: BuildPinterestShareUrlOptions) => {
    const pinterestUrl = new URL(
        'https://www.pinterest.com/pin/create/button/',
    );

    pinterestUrl.searchParams.set('url', new URL(pageUrl).toString());
    pinterestUrl.searchParams.set(
        'media',
        new URL(mediaUrl, pageUrl).toString(),
    );

    const trimmedDescription = description?.trim();

    if (trimmedDescription) {
        pinterestUrl.searchParams.set('description', trimmedDescription);
    }

    return pinterestUrl.toString();
};
